<script lang="ts" setup>
  const chromeExampleImage = new URL('/img/chrome-permission-hint.png', import.meta.url).href
</script>

<template>
  <div class="space-y-4 text-sm">
    <h2 class="text-lg font-semibold">🔔 Push-Benachrichtigungen aktivieren</h2>

    <p>Damit du wichtige Erinnerungen (z.B. zu Kommentaren) nicht verpasst, kannst du Push-Benachrichtigungen aktivieren. Je nach Status deines Browsers gibt es zwei Möglichkeiten:</p>

    <div class="border-l-4 border-green-500 bg-green-50 dark:bg-green-900 dark:border-green-200 p-3">
      <h3 class="font-semibold text-green-700 dark:text-green-200">✅ Du siehst den blauen Hinweis-Banner?</h3>
      <p>
        Klicke einfach auf den Banner und anschließend auf
        <strong>„Benachrichtigungen erlauben“</strong>
        , wenn du dazu aufgefordert wirst. Danach erhältst du automatisch relevante Hinweise direkt im Browser.
      </p>
    </div>

    <div class="border-l-4 border-red-500 bg-red-50 dark:border-red-200 dark:bg-red-900 p-3">
      <h3 class="font-semibold text-red-700 dark:text-red-200">❌ Du siehst keinen Hinweis-Banner?</h3>
      <p>Wahrscheinlich wurden Benachrichtigungen in der Vergangenheit blockiert. Du kannst sie manuell wieder aktivieren:</p>
      <ol class="list-decimal list-inside">
        <li>
          Klicke links neben der Adresszeile auf das Symbol mit den
          <strong>zwei Schiebereglern</strong>
          (⚙️).
        </li>
        <li>
          Wähle unter
          <strong>„Benachrichtigungen“</strong>
          den Button
          <strong>„Berechtigung zurücksetzen“</strong>
          .
        </li>
        <li>Lade die Seite neu.</li>
      </ol>
    </div>

    <div>
      <p class="mb-1 font-medium">📷 Beispiel in Google Chrome:</p>
      <img
        :src="chromeExampleImage"
        alt="Chrome Beispiel"
        class="rounded shadow max-w-xs border" />
    </div>

    <p class="text-xs text-gray-500">Du kannst diese Einstellung jederzeit über die Browsereinstellungen wieder ändern.</p>

    <Message :severity="'info'">
      <span class="font-semibold">Wichtig:</span>
      du wirst keine Benachrichtigungen von deinen eigenen Aktionen erhalten!
    </Message>
  </div>
</template>
